import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  of,
} from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  BookGetModel,
  BookAddModel
} from '../interfaces/interfaces';
import { BACKEND_URL } from '../helpers/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class BookDataService {
  private booksListSubject = new BehaviorSubject<BookGetModel[]>([]);

  private GET_BOOKS = `${BACKEND_URL}/books/getBooks`;
  private DELETE_BOOK = `${BACKEND_URL}/books/deleteBook`;
  private ADD_BOOK = `${BACKEND_URL}/books/addBook`;
  private UPDATE_BOOK = `${BACKEND_URL}/books/updateBook`;
  private UPDATE_BOOK_IMAGES = `${BACKEND_URL}/books/updateBookImages`;

  constructor(private http: HttpClient) { }

  getAllBooksData(): Observable<BookGetModel[]> {
    return this.http
      .get(this.GET_BOOKS)
      .pipe(map((r: any) => Object.values(r['result'])));
  }

  async uploadBookImageData(files: any): Promise<any[]> {
    let promises = [];
    for (let file of files) {
      promises.push(new Promise((resolve, reject) => {
        const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
        const key = moment().valueOf() + '-' + 'book';
        const params = {
          Bucket: 'stotrasagar-images',
          Key: key,
          Body: file,
          ACL: 'public-read',
          ContentType: file.type,
        };

        bucket.upload(params, async (err: any, data: any) => {
          if (err == null) {
            resolve(data.Location)
          } else {
            reject(err)
          }
        });
      })
      )

    }

    return Promise.all(promises)

  }

  // uploadBookImageData(files: any): Observable<string[]> {
  //   let imageLinks: any[] = [];
  //   let imagesSubject = new AsyncSubject<string[]>();

  //   for(let file of files) {
  //     if (file != null) {
  //       const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
  //       const key = moment().valueOf() + '-' + 'book';
  //       const params = {
  //         Bucket: 'stotrasagar-images',
  //         Key: key,
  //         Body: file,
  //         ACL: 'public-read',
  //         ContentType: file.type,
  //       };

  //       bucket.upload(params, async (err: any, data: any) => {
  //         if (err == null) {
  //           imageLinks.push(data.Location);
  //           imagesSubject.next(imageLinks);
  //         } else {
  //         }
  //       });

  //     } else {
  //       imagesSubject.next([]);
  //       imagesSubject.complete();
  //       return imagesSubject.asObservable();
  //     }
  //   }
  //   console.log("image ", imageLinks)

  //   imagesSubject.next(imageLinks);
  //   return imagesSubject;

  // }

  addBookData(addBook: BookAddModel) {
    try {
      return this.http.post(this.ADD_BOOK, addBook).toPromise()
    } catch (err) {
      return err as any
    }
  }

  async deleteBookData(bookId: string, keys: string[]) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
       bookId: bookId
      },
    };
    
    for (let key of keys) {
      await this.deleteBookImage(key);
    }
    return this.http.delete(this.DELETE_BOOK, options).toPromise();
  }

  async deleteBookImage(link: string) {
    return new Promise((resolve, reject) => {
      const key = link.split('/')[3];
      const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
      };

      return s3.deleteObject(params, function (err, data) {
        if (data != null) {
          return resolve("success")
        } else {
          return reject("error")
        }
      });
    });
  }

  async updateBookImageData(bookId: string, links: string[]) {
    return this.http.put(this.UPDATE_BOOK_IMAGES, { imageUrls: links, _id: bookId }).toPromise();
  }

  async deleteBookImageAndUpdate(bookId: string, link: string, links: string[]) {
    const key = link.split('/')[3];
    return new Promise((resolve, reject) => {
      const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
      };

      return s3.deleteObject(params, function (err, data) {
        if (data != null) {
          return resolve("success")
        } else {
          return reject("error")
        }
      });
    });

  }

  async updateBookData(book: BookGetModel) {
    try {
      return this.http.put(this.UPDATE_BOOK, book).toPromise();
    } catch (err) {
      return err as any
    }
  }


}
